module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rating) ? _c('div', {
    staticClass: "rating"
  }, [(_vm.full === 0) ? [_c('span', [_vm._v("暂无评分")])] : [_vm._l((_vm.full), function(n) {
    return [_c('span', {
      staticClass: "star-full"
    })]
  }), _vm._v(" "), _vm._l((_vm.half), function(n) {
    return [_c('span', {
      staticClass: "star-half"
    })]
  }), _vm._v(" "), _vm._l((_vm.gray), function(n) {
    return [_c('span', {
      staticClass: "star-gray"
    })]
  }), _vm._v(" "), _c('span', {
    staticClass: "average"
  }, [_vm._v(_vm._s(_vm.rating.average))])], _vm._v(" "), _vm._t("ratingsCount")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ceb16f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rating.vue
// module id = 203
// module chunks = 0